import React, { useState } from 'react';
import { string, instanceOf, func } from 'prop-types';
import { connect } from 'react-redux';

import { setSurveyDictionayText } from '../../../actions/turnkeyOmnibusActions';

const _validateSpecialChar = a => {
  const re = /^[a-zA-Z0-9 ]*$/;
  const notBlank = a.trim();
  const noSpeical = re.test(a);
  if (notBlank && noSpeical) {
    return true;
  }
  return false;
};

const DictionaryInput = ({
  text,
  currentObj,
  type,
  setError,
  setSurveyDictionayText,
}) => {
  const initialState = {
    value: text.length > 35 ? '' : text,
    error: {
      maxLength: text.length > 35,
      specialChar: !_validateSpecialChar(text),
    },
  };

  const _validateText = value => {
    const error = {
      maxLength: !value || value.length > 35,
      specialChar: !_validateSpecialChar(value),
    };
    return error;
  };

  const [state, setState] = useState(initialState);

  const _handleOnChange = e => {
    const value = e.target.value;
    const error = _validateText(value);
    setState({
      ...state,
      error,
      value,
    });
    setError(error);
  };

  const _handleOnBlur = () => {
    setSurveyDictionayText(state.value, type, currentObj);
  };

  const hasError = state.error.maxLength || state.error.specialChar;
  const maxLengthErrorText =
    'Questionnaire text exceeds 35 character limit. Update text to appear in the study';
  return (
    <div className="ie--dictionary--input-box">
      <input
        type="text"
        value={state.value}
        onChange={_handleOnChange}
        onBlur={_handleOnBlur}
        className={
          hasError
            ? 'ie--dictionary--input ie--dictionary--input--error'
            : 'ie--dictionary--input'
        }
        placeholder={state.error.maxLength ? maxLengthErrorText : ''}
        maxLength="35"
      />
    </div>
  );
};

DictionaryInput.propTypes = {
  text: string,
  currentObj: instanceOf(Object),
  setSurveyDictionayText: func,
  setError: func,
  type: string,
};

export default connect(
  null,
  { setSurveyDictionayText }
)(DictionaryInput);
